import axios from '../axios';
import { checkResponse } from '../utils';
import { apiV1 } from '../utils/constant';

/**
 * @function getCompanySetting
 * @desc 企业设置信息
 * @param {String} companyId 企业id
 */
function getCompanySetting(companyId) {
  return axios.get(`${apiV1}/sw/companySetting/all?companyId=${companyId}`).then(checkResponse);
}

/**
 * @function getDomain
 * @desc 域名反查企业信息
 * @param {String} domain 域名
 */
function getDomain(service, domain) {
  return axios
    .get(`${apiV1}/sw/company/info/domain?service=${service}&domain=${domain}`)
    .then(checkResponse);
}

export { getCompanySetting, getDomain };
